import {
  RankingCharOneTrophy,
  RankingCharThreeTrophy,
  RankingCharTwoTrophy,
  RankingFive,
  RankingFour,
  RankingOne,
  RankingThree,
  RankingTwo,
} from '@viewup/ui';

export const rankOrderMap = {
  1: 2,
  2: 1,
  3: 3,
};

const trophies = {
  1: <RankingOne height={40} width={40} />,
  2: <RankingTwo />,
  3: <RankingThree />,
  4: <RankingFour />,
  5: <RankingFive />,
};

const chars = {
  1: <RankingCharOneTrophy />,
  2: <RankingCharTwoTrophy />,
  3: <RankingCharThreeTrophy />,
};

export const exchangeRankingImage = (rank: number) => {
  return {
    char: chars[rank],
    trophy: trophies[rank],
  };
};
